// src/components/PeoplePlan/Tables/RestaurantManagersTable.js
import React from "react";
import GenericEmployeeTable from "../EmployeeManagement/GenericEmployeeTable";
import { ROLE_CONFIGS } from "../configs/roleConfigs";

function RestaurantManagersTable({ selectedMUM, storeData, onNavigateToProfile }) {
  return (
    <GenericEmployeeTable
      selectedMUM={selectedMUM}
      storeData={storeData}
      roleConfig={ROLE_CONFIGS.RESTAURANT_MANAGER}
      onNavigateToProfile={onNavigateToProfile}
      enableSorting={false}
    />
  );
}

export default RestaurantManagersTable;